export default axios => ({
  getList () {
    return axios.get('/procedure_type')
  },
  getItem (id) {
    return axios.get(`/procedure_type/${id}`)
  },
  update (id, payload) {
    return axios.patch(`/procedure_type/${id}`, payload)
  },
  delete (id) {
    return axios.delete(`/procedure_type/${id}`)
  },
  create (payload) {
    return axios.post('/procedure_type', payload)
  }
})
